export default {
  count: {
    id: 'search_products_count',
    defaultMessage: '{count} products',
  },
}
